import httpClient from './httpClient';

const fetchAllOutlets = async () => {
  const response = await httpClient.get({
    pre: '',
    endpoint: 'all',
    aft: '',
    baseUrl: 'Outlets'
  });
  return response;
};

export default fetchAllOutlets;
